import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const { isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const refresh = useCallback(() => (isSignedIn ? api("get", "/me").then(setMe).catch(() => setMe(null)) : setMe(null)), [isSignedIn, api]);
  useEffect(() => { refresh(); }, [refresh]);
  return <MeCtx.Provider value={me && { ...me, refresh }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
export const isAdminRole = (me) => ["superadmin", "admin"].includes(me?.role);
